import { apiClient } from './apiClient';
import { LocationServicePage } from '../types/locationServicePage';

export const locationServicePageService = {
  // List all location-service pages for tenant
  async list(tenantId: string, status?: string) {
    const params = new URLSearchParams({ tenant_id: tenantId });
    if (status) params.append('status', status);

    const response = await apiClient.get<LocationServicePage[]>(
      `/location-service-pages/list?${params}`
    );
    return response.data;
  },

  // Get single location-service page
  async get(id: string) {
    const response = await apiClient.get<LocationServicePage>(`/location-service-pages/page/${id}`);
    return response.data;
  },

  // Trigger crew to generate location-service page
  async generateWithCrew(inputs: {
    location: string;
    service: string;
    keyword?: string;
    tenant_id: string;
    // ... other inputs
  }) {
    const response = await apiClient.post('/crews/crew-location-service/kickoff', {
      inputs,
    });
    return response.data;
  },

  // Update existing page
  async update(id: string, data: Partial<LocationServicePage>) {
    const response = await apiClient.put<LocationServicePage>(`/location-service-pages/page/${id}`, data);
    return response.data;
  },

  // Delete page
  async delete(id: string) {
    const response = await apiClient.delete(`/location-service-pages/page/${id}`);
    return response.data;
  },

  // Publish page
  async publish(id: string) {
    const response = await apiClient.post(`/location-service-pages/page/${id}/publish`);
    return response.data;
  },
};
